import * as React from 'react';

const SvgActionEditCircle = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z" }),
  React.createElement("path", { fill: "#2D2E2E", d: "M7.5 14.5v2h2l5.03-5.03-2-2L7.5 14.5ZM14.996 7 13.58 8.414l2.002 2.001 1.414-1.414-2.001-2Z" })
);

export { SvgActionEditCircle as default };
//# sourceMappingURL=ActionEditCircle.es.js.map
